export class PaymentStripeController {

  constructor($scope, $rootScope, $location, $window, $timeout, PaymentService, toastr, STRIPE_PK) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.location = $location;
    this.window = $window;
    this.timeout = $timeout;
    this.PaymentService = PaymentService;
    this.toastr = toastr;
    this.stripePk = STRIPE_PK;

    this.init();
  }

  init() {
    const price = this.rootScope.payment_price;
    const days = this.rootScope.payment_days;

    if (!price || !days) {
      this.location.path('/homerd/centrodepago');
      return;
    }

    this.scope.payment_price = price;
    this.scope.payment_days = days;
    this.scope.loadingIntent = true;
    this.scope.processing = false;
    this.scope.cardError = null;

    const stripeKey = this.stripePk;
    if (!stripeKey || typeof this.window.Stripe !== 'function') {
      this.toastr.error('Configuración de pago no disponible. Por favor intenta otro método.');
      this.location.path('/homerd/centrodepago');
      return;
    }

    const stripe = this.window.Stripe(stripeKey);
    let cardElement;

    this.PaymentService.stripeInit(price, days)
      .then((response) => {
        const clientSecret = response.data.clientSecret;
        this.scope.loadingIntent = false;

        // Mount card element after DOM renders
        this.timeout(() => {
          const elements = stripe.elements({locale: 'es'});
          cardElement = elements.create('card', {
            style: {
              base: {
                color: '#333',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {color: '#aab7c4'}
              },
              invalid: {color: '#e53935', iconColor: '#e53935'}
            }
          });
          cardElement.mount('#stripe-card-element');

          cardElement.on('change', (event) => {
            this.scope.$apply(() => {
              this.scope.cardError = event.error ? event.error.message : null;
            });
          });

          this.scope.submitPayment = () => {
            if (this.scope.processing) return;
            this.scope.processing = true;
            this.scope.cardError = null;

            stripe.confirmCardPayment(clientSecret, {
              payment_method: {card: cardElement}
            }).then((result) => {
              this.scope.$apply(() => {
                if (result.error) {
                  this.scope.cardError = result.error.message;
                  this.scope.processing = false;
                } else if (result.paymentIntent.status === 'succeeded') {
                  this.location.path('/homerd/centrodepago/success');
                } else {
                  this.scope.cardError = 'Pago no completado. Por favor intenta nuevamente.';
                  this.scope.processing = false;
                }
              });
            });
          };
        }, 0);
      })
      .catch((response) => {
        console.error('Stripe init error', response);
        this.toastr.error('Error al inicializar el pago. Por favor intenta nuevamente.');
        this.location.path('/homerd/centrodepago/fail');
      });
  }
}
